























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ResponseCodeEnum, DeliveryDateModel, TireStoringContract } from '@/models';

// service
import { tireStoringContractService, vehicleService, homeService } from '@/services';
import { Moment } from 'moment';

@Component
export default class DeliveryDate extends Vue {
  @Prop() public model!: DeliveryDateModel;
  @Prop() private isChooseDate!: boolean;
  @Prop() private total!: number;
  private dateName: string = '';
  private isShow: boolean = false;
  private isDeadline: boolean = false;

  private async created() {
    this.dateName = this.$moment(this.model.date).format('dd');
    const date6Temp = this.$moment().add(3, 'M').startOf('month');
    const dateTemp = this.$moment(this.model.date).startOf('date');
    const dateTempDt = this.model.date;
    const dateTempDeadline = this.model.dateDeadlineWarehouse;
    // compare two date format 'YYYY-MM-DD'
    if (this.$moment() > dateTemp || dateTemp > date6Temp) {
        this.isShow = false;
    } else {
      this.isShow = true;
    }
    if (dateTempDt < dateTempDeadline) {
      this.isDeadline = true;
    }
  }

  private action() {
    if (this.model && this.model.totalDelivery !== null && this.model.totalDelivery !== undefined) {
      if (this.model.isDelivery) {
        this.$router.push({
          name: 'routes.delivery_request',
          query: {
            date: this.$moment(this.model.date).format('YYYY-MM-DD'),
            total_delivery: this.model.totalDelivery.toString(),
          },
        });
      } else {
        if (this.isChooseDate) {
          this.$emit('input', this.model.date);
        } else {
          this.$router.push({
            name: 'routes.search-contract-pickup',
            query: {
              date: this.model.date.toString(),
              total_pickup: this.model.totalDelivery.toString(),
            },
          });
        }
      }
    }
  }
}
